import { useEffect, useState } from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { Sidebar } from '@/components/layout/Sidebar';
import { Header } from '@/components/layout/Header';
import { NotificationsContainer } from '@/components/ui/NotificationsContainer';
import { UnsavedChangesBar } from '@/components/config/UnsavedChangesBar';
import { useGameStore } from '@/stores/game.store';
import { getGameById } from '@/config/games';
import styles from './AdminLayout.module.scss';

export function AdminLayout() {
  // Change de jeu => remonte les pages pour refetch les données du bon backend.
  const activeGameId = useGameStore((s) => s.activeGameId);

  // Menu mobile (sidebar en overlay sur petit écran)
  const [navOpen, setNavOpen] = useState(false);
  const location = useLocation();

  // Ferme le menu à chaque changement de page
  useEffect(() => {
    setNavOpen(false);
  }, [location.pathname]);

  // Applique l'accent du jeu actif (orange = Paladium, bleu = NationsGlory).
  // Nettoie au démontage pour revenir au violet Recube (ex: écran de login).
  useEffect(() => {
    const { accent } = getGameById(activeGameId);
    const root = document.documentElement;
    root.style.setProperty('--color-primary', accent.primary);
    root.style.setProperty('--color-primary-hover', accent.hover);
    root.style.setProperty('--color-primary-light', accent.light);
    return () => {
      root.style.removeProperty('--color-primary');
      root.style.removeProperty('--color-primary-hover');
      root.style.removeProperty('--color-primary-light');
    };
  }, [activeGameId]);

  return (
    <div className={styles.layout}>
      <Sidebar open={navOpen} />

      {navOpen && <div className={styles.navOverlay} onClick={() => setNavOpen(false)} />}

      <div className={styles.main}>
        <Header onMenuClick={() => setNavOpen((v) => !v)} />

        <main className={styles.content}>
          <Outlet key={activeGameId} />
        </main>
      </div>

      <UnsavedChangesBar />
      <NotificationsContainer />
    </div>
  );
}
